import React from 'react';
import legalContent from './legal-content.json';

export function LegalDocumentView({ kind, onBack }) {
  const doc = kind === 'terms' ? legalContent.terms : legalContent.privacy;
  return (
    <div className="panel legal-doc-panel">
      <div className="legal-doc-toolbar">
        <button type="button" className="btn-secondary legal-doc-back" onClick={onBack}>
          ← 返回
        </button>
      </div>
      <h2 className="panel-title">{doc.title}</h2>
      <p className="legal-doc-updated">更新日期：{doc.updated}</p>
      <div className="legal-doc-body">
        {doc.sections.map((sec, i) => (
          <section key={i} className="legal-doc-section">
            <h3 className="legal-doc-heading">{sec.heading}</h3>
            {sec.paragraphs.map((p, j) => (
              <p key={j} className="legal-doc-para">
                {p}
              </p>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}
